/**
 * Wypłata pracownika przychodzi z opóźnieniem 2 tygodni względem końca okresu:
 *   - okres 01-15.MM.YYYY  → wypłata 30.MM.YYYY  (albo ostatni dzień miesiąca)
 *   - okres 16-30.MM.YYYY  → wypłata 15.(MM+1).YYYY
 *
 * Funkcja przyjmuje `period` w formacie "01-15" lub "16-30" oraz `month` (1-12)
 * i `year` (4-cyfrowy). Zwraca string typu "30.09.2026" gotowy do wyświetlenia.
 */
export function computePayoutDate(period, month, year) {
  const m = parseInt(month, 10);
  const y = parseInt(year, 10);
  if (!period || !m || !y) return "";
  const isFirstHalf = String(period).startsWith("01");
  if (isFirstHalf) {
    // Ostatni dzień miesiąca (fallback 30, kwiecień/czerwiec/wrzesień/listopad = 30, luty = 28/29)
    const lastDay = new Date(y, m, 0).getDate();
    return `${String(lastDay).padStart(2, "0")}.${String(m).padStart(2, "0")}.${y}`;
  }
  // Druga połowa: 15 następnego miesiąca
  let nm = m + 1;
  let ny = y;
  if (nm > 12) {
    nm = 1;
    ny = y + 1;
  }
  return `15.${String(nm).padStart(2, "0")}.${ny}`;
}

/**
 * Wariant dla rekordów wypłaty z polami `period_start` + `month` + `year`.
 * `period_start` bywa "01" lub "16" (albo starsze "15") — normalizujemy.
 */
export function payoutDateFromRecord(record) {
  if (!record) return "";
  const raw = String(record.period_start || record.period || "");
  const period = raw === "15" || raw === "16" ? "16-30" : "01-15";
  return computePayoutDate(period, record.month, record.year);
}

/**
 * Wariant dla paliwo-draft: {target_year, target_month, target_period}
 * gdzie target_period to już "01-15" albo "16-30".
 */
export function payoutDateFromDraft(draft) {
  if (!draft) return "";
  return computePayoutDate(
    draft.target_period,
    draft.target_month,
    draft.target_year,
  );
}
